import { useRef, useState } from "react";
import { createPortal } from "react-dom";

// A hover-triggered icon + tooltip rendered via a portal to document.body,
// positioned with `position: fixed` from the icon's own getBoundingClientRect.
// Needed because CSS overflow-y:auto (used by ScrollableList) forces
// overflow-x to clip too, per spec — a plain CSS group-hover tooltip nested
// inside a scrollable list gets its overflow-x clipped by that same
// ancestor, cutting the tooltip off at the list's right edge. A portal
// escapes every ancestor's overflow/clipping context, since it's not a DOM
// descendant of them anymore.
export function HoverTooltip({ icon, iconClassName = "", children }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const ref = useRef(null);

  const show = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos({ top: rect.top + rect.height / 2, left: rect.right + 6 });
    setOpen(true);
  };
  const hide = () => setOpen(false);

  return (
    <>
      <span
        ref={ref}
        onMouseEnter={show}
        onMouseLeave={hide}
        className={`material-symbols-outlined cursor-help align-middle leading-none ${iconClassName}`}
      >
        {icon}
      </span>
      {open && pos && createPortal(
        <div
          style={{ position: "fixed", top: pos.top, left: pos.left, transform: "translateY(-50%)" }}
          className="pointer-events-none z-[9999] w-44 rounded-lg border border-white/10 bg-[#0d1421] p-2 text-[10px] font-normal normal-case leading-snug text-slate-300 shadow-xl"
        >
          {children}
        </div>,
        document.body
      )}
    </>
  );
}
